import Typography from '@mui/material/Typography';
import { moneyFormat } from 'shared/utils/functions';
import Mui5Link from '../components/atoms/Link';
import { styled } from '@mui/material/styles';

type Props = {
  image: string;
  auctionId: number;
  make: string;
  model: string;
  trim: string;
  year: number;
  msrp: number;
  disableLink?: boolean;
  onAuctionLinkClick?: () => void;
};

const Preview = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1),
}));

const StyledImg = styled('img')(() => ({
  height: 70,
  width: 'auto',
  marginRight: 10,
}));

const AuctionSummary = ({
  image,
  auctionId,
  make,
  model,
  trim,
  year,
  msrp,
  disableLink,
  onAuctionLinkClick,
}: Props): JSX.Element => {
  return (
    <Preview>
      <StyledImg src={image} />
      <div>
        <Typography
          display='block'
          variant='body2'
          sx={{ whiteSpace: 'break-spaces' }}
        >
          {!disableLink && (
            <Mui5Link
              onClick={() => onAuctionLinkClick?.()}
              sx={{ fontSize: '1rem' }}
              href={`/deals/${auctionId}`}
            >
              {make} {model} {trim || ''}
            </Mui5Link>
          )}
          {disableLink && (
            <>
              {make} {model} {trim || ''}
            </>
          )}
        </Typography>
        <Typography
          display='block'
          variant='body2'
          color='textSecondary'
          noWrap
        >
          {year}
        </Typography>
        <Typography
          display='block'
          variant='body2'
          color='textSecondary'
          noWrap
        >
          MSRP - {moneyFormat(msrp)}
        </Typography>
      </div>
    </Preview>
  );
};

export default AuctionSummary;
